// extracted by mini-css-extract-plugin
export var actionButton = "DeleteButton-module__actionButton___F55bF";
export var cancelButton = "DeleteButton-module__cancelButton___cHBiA";
export var deleteButton = "DeleteButton-module__deleteButton___WHom9";
export var deleteButtonColor = "DeleteButton-module__deleteButtonColor___0sFNa";
export var modalActions = "DeleteButton-module__modalActions___ypXPN";
export var modalBody = "DeleteButton-module__modalBody___Sc8hj";
export var modalHeader = "DeleteButton-module__modalHeader___3V+xS";
export var modalTitle = "DeleteButton-module__modalTitle___pT4rM";